// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.cdnfonts.com/css/avenir);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow+Condensed:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messages-container {
  overflow-y: auto;
  padding: 0.75rem;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  height: calc(100% - 150px);
}
.messages-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: linear-gradient(to bottom, rgba(26, 42, 58, 0.03), transparent);
  pointer-events: none;
}
.messages-container {
  /* Custom scrollbar for the messages container */
}
.messages-container::-webkit-scrollbar {
  width: 6px;
}
.messages-container::-webkit-scrollbar-track {
  background: transparent;
}
.messages-container::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}

.message {
  display: flex;
  margin-bottom: 0.5rem;
  position: relative;
  max-width: 85%;
  font-size: 0.95rem;
  line-height: 1.5;
  transition: all 0.3s ease;
}
.message.new-message {
  opacity: 0;
  transform: translateY(10px);
  animation: messageAppear 0.3s ease forwards;
}
.message.user-message {
  margin-left: auto;
  margin-right: 2px;
}
.message.user-message .message-content {
  color: white;
  border-radius: 1.25rem 0.25rem 1.25rem 1.25rem;
  padding: 0.75rem 1rem;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  font-weight: 400;
  box-shadow: 0 4px 12px rgba(0, 102, 255, 0.2);
  transition: transform 0.2s ease;
}
.message.user-message .message-content:hover {
  transform: translateY(-1px);
}
.message.system-message {
  margin-right: auto;
  margin-left: 2px;
}
.message.system-message .message-content {
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  color: #2c3e50;
  border-radius: 0.25rem 1.25rem 1.25rem 1.25rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08), 0 8px 24px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
  padding: 0.75rem 1rem;
  font-weight: 400;
  letter-spacing: -0.01em;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.message.system-message .message-content:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1), 0 12px 32px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.1);
}

.message-content {
  border-radius: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.message-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.75rem;
  padding: 0.375rem;
  background: rgba(248, 250, 252, 0.5);
  border-radius: 1rem;
  backdrop-filter: blur(8px);
}

.option-button {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 1.5rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);
  color: #007aff;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
  min-width: 120px;
  text-align: center;
  letter-spacing: -0.01em;
}
.option-button::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(0, 122, 255, 0.1) 0%, rgba(0, 122, 255, 0.05) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}
.option-button:hover {
  background: linear-gradient(135deg, #007aff 0%, #0052cc 100%);
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 122, 255, 0.2), 0 2px 4px rgba(0, 0, 0, 0.1);
}
.option-button:hover::before {
  opacity: 1;
}
.option-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 122, 255, 0.2);
}

.checkbox-container {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
  margin-top: 0.75rem;
  padding: 0.75rem;
  background: rgba(248, 250, 252, 0.5);
  border-radius: 1rem;
  backdrop-filter: blur(8px);
}

.option-checkbox {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  padding: 0.75rem;
  border-radius: 0.75rem;
  transition: all 0.2s ease;
  background: rgba(255, 255, 255, 0.8);
}
.option-checkbox:hover {
  background: rgba(0, 122, 255, 0.05);
  transform: translateX(4px);
}
.option-checkbox input[type=checkbox] {
  width: 20px;
  height: 20px;
  border-radius: 6px;
  border: 2px solid #007aff;
  appearance: none;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
  background: white;
}
.option-checkbox input[type=checkbox]:checked {
  background: #007aff;
  border-color: #007aff;
}
.option-checkbox input[type=checkbox]:checked:after {
  content: "";
  position: absolute;
  left: 5px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.option-checkbox input[type=checkbox]:hover {
  border-color: #0052cc;
  transform: scale(1.05);
}

.connecting-animation {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  padding: 2rem;
  text-align: center;
  background: white;
}
.connecting-animation .avatar-container {
  position: relative;
  width: 80px;
  height: 80px;
  margin-bottom: 2rem;
  opacity: 0;
  transform: scale(0.8);
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}
.connecting-animation .avatar-container.visible {
  opacity: 1;
  transform: scale(1);
}
.connecting-animation .avatar-container img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 4px 12px rgba(0, 102, 255, 0.15);
}
.connecting-animation .avatar-container .connecting-ring {
  position: absolute;
  top: -4px;
  left: -4px;
  right: -4px;
  bottom: -4px;
  border: 2px solid #0066ff;
  border-radius: 50%;
  opacity: 0;
  animation: ringPulse 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
.connecting-animation .avatar-container .connecting-ring::after {
  content: "";
  position: absolute;
  top: -4px;
  left: -4px;
  right: -4px;
  bottom: -4px;
  border: 2px solid #0066ff;
  border-radius: 50%;
  animation: ringPulse 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  animation-delay: 0.5s;
}
.connecting-animation .connecting-text {
  color: #2c3e50;
  font-size: 1rem;
  font-weight: 500;
  opacity: 0;
  transform: translateY(10px);
  animation: textFadeIn 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}
.connecting-animation .connecting-text .dots {
  display: inline-flex;
  margin-left: 2px;
}
.connecting-animation .connecting-text .dots span {
  opacity: 0.6;
  animation: dotFade 1.4s infinite;
}
.connecting-animation .connecting-text .dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.connecting-animation .connecting-text .dots span:nth-child(3) {
  animation-delay: 0.4s;
}

.reconnecting-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #2c3e50;
  font-size: 0.95rem;
}
.reconnecting-indicator svg {
  color: #0066ff;
}

@keyframes ringPulse {
  0% {
    transform: scale(1);
    opacity: 0.4;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.2;
  }
  100% {
    transform: scale(1.2);
    opacity: 0;
  }
}
@keyframes textFadeIn {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes dotFade {
  0%, 100% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
}
@keyframes messageAppear {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 600px) {
  .message {
    max-width: 94%;
    font-size: 14px;
  }
  .message.user-message {
    margin-right: 2px;
  }
  .message.system-message {
    margin-left: 2px;
  }
  .message .message-content {
    padding: 10px 14px;
  }
}
.typing-indicator {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0.5rem 0.75rem;
  background: #f8fafc;
  border-radius: 1rem;
  width: fit-content;
}

.dot {
  width: 6px;
  height: 6px;
  background: #0066ff;
  border-radius: 50%;
  opacity: 0.7;
  animation: dotPulse 1.4s infinite;
}
.dot:nth-child(2) {
  animation-delay: 0.2s;
}
.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes dotPulse {
  0%, 100% {
    transform: scale(0.7);
    opacity: 0.4;
  }
  50% {
    transform: scale(1);
    opacity: 0.8;
  }
}
.md-content {
  background: transparent !important;
  color: #2c3e50;
  font-size: 0.95rem;
  line-height: 1.5;
}
.md-content p,
.md-content ul,
.md-content ol {
  margin: 0.375rem 0;
}
.md-content p:first-child,
.md-content ul:first-child,
.md-content ol:first-child {
  margin-top: 0;
}
.md-content p:last-child,
.md-content ul:last-child,
.md-content ol:last-child {
  margin-bottom: 0;
}
.md-content a {
  color: #0066ff;
  text-decoration: none;
  font-weight: 500;
}
.md-content a:hover {
  text-decoration: underline;
}
.md-content code {
  color: #2c3e50;
  background: rgba(44, 62, 80, 0.05);
  padding: 0.2em 0.4em;
  border-radius: 3px;
  font-size: 0.9em;
}

.message-input-container {
  background: #ffffff;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  padding: 1rem;
  position: relative;
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./src/components/chat-body/chat-body.scss"],"names":[],"mappings":"AAGA;EAEC,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,0BAAA;AADD;AAGC;EACC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,2EAAA;EACA,oBAAA;AADF;AAlBA;EAsBC,gDAAA;AADD;AAEC;EACC,UAAA;AAAF;AAGC;EACC,uBAAA;AADF;AAIC;EACC,8BAAA;EACA,kBAAA;AAFF;;AAOA;EACC,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AAJD;AAOC;EACC,UAAA;EACA,2BAAA;EACA,2CAAA;AALF;AAQC;EACC,iBAAA;EACA,iBAAA;AANF;AAQE;EAEC,YAAA;EACA,8CAAA;EACA,qBAAA;EACA,yCAAA;EACA,gBAAA;EACA,6CAAA;EACA,+BAAA;AAPH;AASG;EACC,2BAAA;AAPJ;AAYC;EACC,kBAAA;EACA,gBAAA;AAVF;AAYE;EACC,6DAAA;EACA,cAAA;EACA,8CAAA;EACA,wGACC;EAGD,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qDACC;AAdJ;AAiBG;EACC,2BAAA;EACA,wGACC;AAhBL;;AAwBA;EACC,mBAAA;EACA,yCAAA;AArBD;;AAwBA;EACC,aAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,oCAAA;EACA,mBAAA;EACA,0BAAA;AArBD;;AAwBA;EACC,uBAAA;EACA,YAAA;EACA,qBAAA;EACA,6DAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iDAAA;EACA,uEACC;EAED,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;AAvBD;AAyBC;EACC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,4FAAA;EAKA,UAAA;EACA,6BAAA;AA3BF;AA8BC;EACC,6DAAA;EACA,YAAA;EACA,2BAAA;EACA,2EACC;AA7BH;AAgCE;EACC,UAAA;AA9BH;AAkCC;EACC,wBAAA;EACA,4CAAA;AAhCF;;AAoCA;EACC,aAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,oCAAA;EACA,mBAAA;EACA,0BAAA;AAjCD;;AAoCA;EACC,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,oCAAA;AAjCD;AAmCC;EACC,mCAAA;EACA,0BAAA;AAjCF;AAoCC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;AAlCF;AAoCE;EACC,mBAAA;EACA,qBAAA;AAlCH;AAoCG;EACC,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;AAlCJ;AAsCE;EACC,qBAAA;EACA,sBAAA;AApCH;;AA0CA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;AAvCD;AAyCC;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,qBAAA;EACA,iDAAA;AAvCF;AAyCE;EACC,UAAA;EACA,mBAAA;AAvCH;AA0CE;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,8CAAA;AAxCH;AA2CE;EACC,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,6DAAA;AAzCH;AA2CG;EACC,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,6DAAA;EACA,qBAAA;AAzCJ;AA8CC;EACC,cAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,2BAAA;EACA,gEAAA;AA5CF;AA8CE;EACC,oBAAA;EACA,gBAAA;AA5CH;AA8CG;EACC,YAAA;EACA,gCAAA;AA5CJ;AA8CI;EACC,qBAAA;AA5CL;AA+CI;EACC,qBAAA;AA7CL;;AAqDA;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,kBAAA;AAlDD;AAoDC;EACC,cAAA;AAlDF;;AAsDA;EACC;IACC,mBAAA;IACA,YAAA;EAnDA;EAsDD;IACC,qBAAA;IACA,YAAA;EApDA;EAuDD;IACC,qBAAA;IACA,UAAA;EArDA;AACF;AAwDA;EACC;IACC,UAAA;IACA,2BAAA;EAtDA;EAyDD;IACC,UAAA;IACA,wBAAA;EAvDA;AACF;AA0DA;EACC;IAEC,YAAA;EAzDA;EA4DD;IACC,UAAA;EA1DA;AACF;AA6DA;EACC;IACC,UAAA;IACA,wBAAA;EA3DA;AACF;AA8DA;EAKC;IACC,cAAA;IACA,eAAA;EAhEA;EAkEA;IACC,iBAAA;EAhED;EAmEA;IACC,gBAAA;EAjED;EAoEA;IACC,kBAAA;EAlED;AACF;AAuEA;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AArED;;AAwEA;EACC,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iCAAA;AArED;AAuEC;EACC,qBAAA;AArEF;AAwEC;EACC,qBAAA;AAtEF;;AA0EA;EACC;IAEC,qBAAA;IACA,YAAA;EAxEA;EA2ED;IACC,mBAAA;IACA,YAAA;EAzEA;AACF;AA6EA;EACC,kCAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AA3ED;AA6EC;;;EAGC,kBAAA;AA3EF;AA6EE;;;EACC,aAAA;AAzEH;AA4EE;;;EACC,gBAAA;AAxEH;AA4EC;EACC,cAAA;EACA,qBAAA;EACA,gBAAA;AA1EF;AA4EE;EACC,0BAAA;AA1EH;AA8EC;EACC,cAAA;EACA,kCAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AA5EF;;AAiFA;EACC,mBAAA;EACA,yCAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;AA9ED","sourcesContent":["@use \"../../styles/variables\" as *;\n\n// ChatBody.scss - Message container styles\n.messages-container {\n\t//flex: 1;\n\toverflow-y: auto;\n\tpadding: 0.75rem;\n\tbackground: #ffffff;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 8px;\n\tposition: relative;\n\theight: calc(100% - 150px);\n\n\t&::before {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\theight: 60px;\n\t\tbackground: linear-gradient(to bottom, rgba(26, 42, 58, 0.03), transparent);\n\t\tpointer-events: none;\n\t}\n\n\t/* Custom scrollbar for the messages container */\n\t&::-webkit-scrollbar {\n\t\twidth: 6px;\n\t}\n\n\t&::-webkit-scrollbar-track {\n\t\tbackground: transparent;\n\t}\n\n\t&::-webkit-scrollbar-thumb {\n\t\tbackground: rgba(0, 0, 0, 0.1);\n\t\tborder-radius: 3px;\n\t}\n}\n\n// ChatMessage.scss - Individual message styles\n.message {\n\tdisplay: flex;\n\tmargin-bottom: 0.5rem;\n\tposition: relative;\n\tmax-width: 85%;\n\tfont-size: 0.95rem;\n\tline-height: 1.5;\n\ttransition: all 0.3s ease;\n\n\t// Only animate new messages\n\t&.new-message {\n\t\topacity: 0;\n\t\ttransform: translateY(10px);\n\t\tanimation: messageAppear 0.3s ease forwards;\n\t}\n\n\t&.user-message {\n\t\tmargin-left: auto;\n\t\tmargin-right: 2px;\n\n\t\t.message-content {\n\t\t\t// background: linear-gradient(135deg, #0066FF 0%, #0052CC 100%);\n\t\t\tcolor: white;\n\t\t\tborder-radius: 1.25rem 0.25rem 1.25rem 1.25rem;\n\t\t\tpadding: 0.75rem 1rem;\n\t\t\ttext-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\n\t\t\tfont-weight: 400;\n\t\t\tbox-shadow: 0 4px 12px rgba(0, 102, 255, 0.2);\n\t\t\ttransition: transform 0.2s ease;\n\n\t\t\t&:hover {\n\t\t\t\ttransform: translateY(-1px);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.system-message {\n\t\tmargin-right: auto;\n\t\tmargin-left: 2px;\n\n\t\t.message-content {\n\t\t\tbackground: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);\n\t\t\tcolor: #2c3e50;\n\t\t\tborder-radius: 0.25rem 1.25rem 1.25rem 1.25rem;\n\t\t\tbox-shadow:\n\t\t\t\t0 4px 12px rgba(0, 0, 0, 0.08),\n\t\t\t\t0 8px 24px rgba(0, 0, 0, 0.05),\n\t\t\t\t0 1px 2px rgba(0, 0, 0, 0.1);\n\t\t\tpadding: 0.75rem 1rem;\n\t\t\tfont-weight: 400;\n\t\t\tletter-spacing: -0.01em;\n\t\t\ttransition:\n\t\t\t\ttransform 0.2s ease,\n\t\t\t\tbox-shadow 0.2s ease;\n\n\t\t\t&:hover {\n\t\t\t\ttransform: translateY(-1px);\n\t\t\t\tbox-shadow:\n\t\t\t\t\t0 6px 16px rgba(0, 0, 0, 0.1),\n\t\t\t\t\t0 12px 32px rgba(0, 0, 0, 0.06),\n\t\t\t\t\t0 1px 2px rgba(0, 0, 0, 0.1);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.message-content {\n\tborder-radius: 1rem;\n\tbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.message-buttons {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tgap: 0.5rem;\n\tmargin-top: 0.75rem;\n\tpadding: 0.375rem;\n\tbackground: rgba(248, 250, 252, 0.5);\n\tborder-radius: 1rem;\n\tbackdrop-filter: blur(8px);\n}\n\n.option-button {\n\tpadding: 0.75rem 1.5rem;\n\tborder: none;\n\tborder-radius: 1.5rem;\n\tbackground: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);\n\tcolor: #007aff;\n\tfont-size: 1rem;\n\tfont-weight: 600;\n\tcursor: pointer;\n\ttransition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n\tbox-shadow:\n\t\t0 2px 8px rgba(0, 0, 0, 0.05),\n\t\t0 1px 2px rgba(0, 0, 0, 0.1);\n\tposition: relative;\n\toverflow: hidden;\n\tmin-width: 120px;\n\ttext-align: center;\n\tletter-spacing: -0.01em;\n\n\t&::before {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\tbackground: linear-gradient(\n\t\t\t135deg,\n\t\t\trgba(0, 122, 255, 0.1) 0%,\n\t\t\trgba(0, 122, 255, 0.05) 100%\n\t\t);\n\t\topacity: 0;\n\t\ttransition: opacity 0.3s ease;\n\t}\n\n\t&:hover {\n\t\tbackground: linear-gradient(135deg, #007aff 0%, #0052cc 100%);\n\t\tcolor: white;\n\t\ttransform: translateY(-2px);\n\t\tbox-shadow:\n\t\t\t0 4px 12px rgba(0, 122, 255, 0.2),\n\t\t\t0 2px 4px rgba(0, 0, 0, 0.1);\n\n\t\t&::before {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\n\t&:active {\n\t\ttransform: translateY(0);\n\t\tbox-shadow: 0 2px 4px rgba(0, 122, 255, 0.2);\n\t}\n}\n\n.checkbox-container {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 0.75rem;\n\twidth: 100%;\n\tmargin-top: 0.75rem;\n\tpadding: 0.75rem;\n\tbackground: rgba(248, 250, 252, 0.5);\n\tborder-radius: 1rem;\n\tbackdrop-filter: blur(8px);\n}\n\n.option-checkbox {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 0.75rem;\n\tcursor: pointer;\n\tpadding: 0.75rem;\n\tborder-radius: 0.75rem;\n\ttransition: all 0.2s ease;\n\tbackground: rgba(255, 255, 255, 0.8);\n\n\t&:hover {\n\t\tbackground: rgba(0, 122, 255, 0.05);\n\t\ttransform: translateX(4px);\n\t}\n\n\tinput[type=\"checkbox\"] {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tborder-radius: 6px;\n\t\tborder: 2px solid #007aff;\n\t\tappearance: none;\n\t\tcursor: pointer;\n\t\tposition: relative;\n\t\ttransition: all 0.2s ease;\n\t\tbackground: white;\n\n\t\t&:checked {\n\t\t\tbackground: #007aff;\n\t\t\tborder-color: #007aff;\n\n\t\t\t&:after {\n\t\t\t\tcontent: \"\";\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 5px;\n\t\t\t\ttop: 2px;\n\t\t\t\twidth: 5px;\n\t\t\t\theight: 10px;\n\t\t\t\tborder: solid white;\n\t\t\t\tborder-width: 0 2px 2px 0;\n\t\t\t\ttransform: rotate(45deg);\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\tborder-color: #0052cc;\n\t\t\ttransform: scale(1.05);\n\t\t}\n\t}\n}\n\n// Initial loading animation styles\n.connecting-animation {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tmin-height: 300px;\n\tpadding: 2rem;\n\ttext-align: center;\n\tbackground: white;\n\n\t.avatar-container {\n\t\tposition: relative;\n\t\twidth: 80px;\n\t\theight: 80px;\n\t\tmargin-bottom: 2rem;\n\t\topacity: 0;\n\t\ttransform: scale(0.8);\n\t\ttransition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);\n\n\t\t&.visible {\n\t\t\topacity: 1;\n\t\t\ttransform: scale(1);\n\t\t}\n\n\t\timg {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tborder-radius: 50%;\n\t\t\tobject-fit: cover;\n\t\t\tbox-shadow: 0 4px 12px rgba(0, 102, 255, 0.15);\n\t\t}\n\n\t\t.connecting-ring {\n\t\t\tposition: absolute;\n\t\t\ttop: -4px;\n\t\t\tleft: -4px;\n\t\t\tright: -4px;\n\t\t\tbottom: -4px;\n\t\t\tborder: 2px solid #0066ff;\n\t\t\tborder-radius: 50%;\n\t\t\topacity: 0;\n\t\t\tanimation: ringPulse 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n\n\t\t\t&::after {\n\t\t\t\tcontent: \"\";\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: -4px;\n\t\t\t\tleft: -4px;\n\t\t\t\tright: -4px;\n\t\t\t\tbottom: -4px;\n\t\t\t\tborder: 2px solid #0066ff;\n\t\t\t\tborder-radius: 50%;\n\t\t\t\tanimation: ringPulse 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n\t\t\t\tanimation-delay: 0.5s;\n\t\t\t}\n\t\t}\n\t}\n\n\t.connecting-text {\n\t\tcolor: #2c3e50;\n\t\tfont-size: 1rem;\n\t\tfont-weight: 500;\n\t\topacity: 0;\n\t\ttransform: translateY(10px);\n\t\tanimation: textFadeIn 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;\n\n\t\t.dots {\n\t\t\tdisplay: inline-flex;\n\t\t\tmargin-left: 2px;\n\n\t\t\tspan {\n\t\t\t\topacity: 0.6;\n\t\t\t\tanimation: dotFade 1.4s infinite;\n\n\t\t\t\t&:nth-child(2) {\n\t\t\t\t\tanimation-delay: 0.2s;\n\t\t\t\t}\n\n\t\t\t\t&:nth-child(3) {\n\t\t\t\t\tanimation-delay: 0.4s;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n// Reconnecting indicator\n.reconnecting-indicator {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n\tcolor: #2c3e50;\n\tfont-size: 0.95rem;\n\n\tsvg {\n\t\tcolor: #0066ff;\n\t}\n}\n\n@keyframes ringPulse {\n\t0% {\n\t\ttransform: scale(1);\n\t\topacity: 0.4;\n\t}\n\n\t50% {\n\t\ttransform: scale(1.1);\n\t\topacity: 0.2;\n\t}\n\n\t100% {\n\t\ttransform: scale(1.2);\n\t\topacity: 0;\n\t}\n}\n\n@keyframes textFadeIn {\n\t0% {\n\t\topacity: 0;\n\t\ttransform: translateY(10px);\n\t}\n\n\t100% {\n\t\topacity: 1;\n\t\ttransform: translateY(0);\n\t}\n}\n\n@keyframes dotFade {\n\t0%,\n\t100% {\n\t\topacity: 0.3;\n\t}\n\n\t50% {\n\t\topacity: 1;\n\t}\n}\n\n@keyframes messageAppear {\n\tto {\n\t\topacity: 1;\n\t\ttransform: translateY(0);\n\t}\n}\n\n@media (max-width: $mobile_breakpoint) {\n\t.messages-container {\n\t\t//padding: 16px 8px;\n\t}\n\n\t.message {\n\t\tmax-width: 94%;\n\t\tfont-size: 14px;\n\n\t\t&.user-message {\n\t\t\tmargin-right: 2px;\n\t\t}\n\n\t\t&.system-message {\n\t\t\tmargin-left: 2px;\n\t\t}\n\n\t\t.message-content {\n\t\t\tpadding: 10px 14px;\n\t\t}\n\t}\n}\n\n// Typing indicator\n.typing-indicator {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 4px;\n\tpadding: 0.5rem 0.75rem;\n\tbackground: #f8fafc;\n\tborder-radius: 1rem;\n\twidth: fit-content;\n}\n\n.dot {\n\twidth: 6px;\n\theight: 6px;\n\tbackground: #0066ff;\n\tborder-radius: 50%;\n\topacity: 0.7;\n\tanimation: dotPulse 1.4s infinite;\n\n\t&:nth-child(2) {\n\t\tanimation-delay: 0.2s;\n\t}\n\n\t&:nth-child(3) {\n\t\tanimation-delay: 0.4s;\n\t}\n}\n\n@keyframes dotPulse {\n\t0%,\n\t100% {\n\t\ttransform: scale(0.7);\n\t\topacity: 0.4;\n\t}\n\n\t50% {\n\t\ttransform: scale(1);\n\t\topacity: 0.8;\n\t}\n}\n\n// Markdown content\n.md-content {\n\tbackground: transparent !important;\n\tcolor: #2c3e50;\n\tfont-size: 0.95rem;\n\tline-height: 1.5;\n\n\tp,\n\tul,\n\tol {\n\t\tmargin: 0.375rem 0;\n\n\t\t&:first-child {\n\t\t\tmargin-top: 0;\n\t\t}\n\n\t\t&:last-child {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t}\n\n\ta {\n\t\tcolor: #0066ff;\n\t\ttext-decoration: none;\n\t\tfont-weight: 500;\n\n\t\t&:hover {\n\t\t\ttext-decoration: underline;\n\t\t}\n\t}\n\n\tcode {\n\t\tcolor: #2c3e50;\n\t\tbackground: rgba(44, 62, 80, 0.05);\n\t\tpadding: 0.2em 0.4em;\n\t\tborder-radius: 3px;\n\t\tfont-size: 0.9em;\n\t}\n}\n\n// Make message input area solid\n.message-input-container {\n\tbackground: #ffffff;\n\tborder-top: 1px solid rgba(0, 0, 0, 0.08);\n\tpadding: 1rem;\n\tposition: relative;\n\tz-index: 2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
